export default "__VITE_ASSET__8d8cb63b__"